module.exports = __webpack_public_path__ + "static/media/sp28.0ceaf4f6.JPG";